module.exports = "from microbit import *\n"